import React, { Fragment, useState } from 'react';
import { Icon, Divider, Modal } from 'semantic-ui-react';
import { compose, lifecycle } from 'recompose';
import log from 'loglevel';
import ReactGA from 'react-ga';
import urlJoin from 'url-join';
import { COLOR } from '@tcaster/tcaster-theme';

import { Box, Flex, Button, Text, Link, Image } from 'src/Components/Base';
import { SPACE } from 'src/Components/Theme';
import CloseButton from 'src/Components/CloseButton';
import Loading from 'src/Components/Loading';
import { withFacebook } from 'src/Util/HOC/FacebookSDK';

const getSharingUrl = (url = '') => {
  const result = /(dek([\d]+))(.*)/.exec(url);
  return result ? urlJoin(`https://sobtid-sharing.tcaster.net`, url) : null;
};

function sharingTwitter(url, initialText) {
  try {
    ReactGA.event({
      category: 'CONFIRM_ADMISSION',
      action: 'Share via Twitter',
    });
  } catch (err) {
    log.error('ga error:', err);
  }
  window.open(
    'http://twitter.com/share?url=' +
      encodeURIComponent(url) +
      '&text=' +
      encodeURIComponent(initialText),
    '',
    'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0',
  );
}

function SharingSection({ shareUrl, imageUrl, onShareTwitter, onShareFacebook }) {
  return (
    <Flex
      justifyContent="center"
      mt={SPACE.large}
      width={'100%'}
      flexDirection={['column', null, 'row']}
    >
      <Box width={1}>
        <Button
          circular
          size="medium"
          color="facebook"
          onClick={onShareFacebook}
          content={
            <span style={{ fontWeight: 400 }}>
              <Icon name="facebook" />
              แชร์ผลไปยัง Facebook
            </span>
          }
          fluid
        />
      </Box>
      <Box flex="0 0 16px" />
      <Box width={1}>
        <Button
          circular
          size="medium"
          color="twitter"
          onClick={onShareTwitter}
          content={
            <span style={{ fontWeight: 400 }}>
              <Icon name="twitter" />
              แชร์ผลไปยัง Twitter
            </span>
          }
          fluid
        />
      </Box>
    </Flex>
  );
}

function MyAdmission(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    sharingPath,
    sharingImagePath,
    facebookContext,
    onDeleteAdmissionDetail,
    // facebookGroupId = '2221516901257399',
  } = props;
  const { FB } = facebookContext;

  const shareUrl = getSharingUrl(sharingPath);
  const imageUrl = getSharingUrl(sharingImagePath);

  const renderModal = () => (
    <Modal
      dimmer="inverted"
      size="tiny"
      closeOnDimmerClick={false}
      open={isModalOpen}
      onClose={e => setIsModalOpen(false)}
    >
      <Modal.Header>
        <Flex justifyContent="space-between" alignItems="center">
          {/* <Box>แชร์แล้วลุ้นรางวัล</Box> */}
          <Box></Box>
          <CloseButton onClick={e => setIsModalOpen(false)}></CloseButton>
        </Flex>
      </Modal.Header>
      <Modal.Content>
        <Modal.Description style={{ textAlign: 'center', minHeight: 150 }}>
          <Image
            width="100%"
            height="auto"
            src={'/images/confirm/dek64-announcement.png'}
            style={{ maxWidth: 'unset' }}
          />
          <Box my={2}></Box>
          <Link
            as={Button}
            circular
            size="medium"
            color="primary"
            content={`ติดตามเพจ TCASter ตอนนี้`}
            href="https://www.facebook.com/TCASterApp"
            target="_blank"
            rel="noopener noreferrer"
            fluid
          />
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );

  return (
    <Fragment>
      <Flex alignItems="center" flexDirection="column" style={{ maxWidth: 600 }} mx={'auto'}>
        {imageUrl ? (
          <Box>
            {/* <Text.Title>สำเร็จแล้ว! แชร์ผลได้เลย</Text.Title> */}
            <Image width="100%" height="auto" src={imageUrl} style={{ maxWidth: 'unset' }} />
          </Box>
        ) : (
          <Loading loadingText="โหลดรูปอยู่แปร๊บ..." />
        )}
        {shareUrl !== null && imageUrl !== null && (
          <Fragment>
            <SharingSection
              shareUrl={shareUrl}
              imageUrl={imageUrl}
              onShareTwitter={() => {
                try {
                  ReactGA.event({
                    category: 'CONFIRM_ADMISSION',
                    action: 'Share via Twitter',
                  });
                } catch (err) {
                  log.error('ga error:', err);
                }
                sharingTwitter(shareUrl, '#ติดแล้วบอกต่อ #TCASter #DEK65');
              }}
              onShareFacebook={() => {
                try {
                  ReactGA.event({
                    category: 'CONFIRM_ADMISSION',
                    action: 'Share via Facebook',
                  });
                } catch (err) {
                  log.error('ga error:', err);
                }
                FB.ui(
                  {
                    method: 'share',
                    href: shareUrl,
                    hashtag: '#ติดแล้วบอกต่อ',
                  },
                  function(response) {
                    log.debug('fb response:', response);
                  },
                );
              }}
            />

            <Box mt={SPACE.medium} style={{ width: '100%' }}>
              <Button
                basic
                primary
                circular
                style={{ width: '100%' }}
                onClick={onDeleteAdmissionDetail}
              >
                <Text color="primary" fontSize={3} fontWeight="bold" style={{ lineHeight: 1.2 }}>
                  สร้างรูปใหม่
                </Text>
              </Button>
            </Box>
          </Fragment>
        )}
      </Flex>
      {renderModal()}
    </Fragment>
  );
}

export default compose(
  withFacebook,
  lifecycle({
    componentDidMount() {
      try {
        this.props.facebookContext.FB.XFBML.parse();
      } catch (err) {
        log.error('fb error:', err);
      }
      try {
        ReactGA.event({
          category: 'CONFIRM_ADMISSION',
          action: 'View Share Image',
        });
      } catch (err) {
        log.error('ga error:', err);
      }
    },
  }),
)(MyAdmission);
